<template>
  <div>
    <vs-popup :title="$t('DeviceInfo')" :active.sync="showModal">
      <vs-table :data="deviceDetails">
        <template :name="{ data }" slot-scope="{ data }">
          <vs-tr>
            <vs-td>
              {{ $t("BasketId") }}
            </vs-td>
            <vs-td>
              {{ deviceDetails.basketId }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>
              {{ $t("DeviceType") }}
            </vs-td>
            <vs-td>
              <span v-if="deviceDetails.isDesktop == true">
                {{ $t("Desktop") }}
              </span>
              <span v-if="deviceDetails.isDesktop == false">
                {{ $t("Mobile") }}
              </span>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>
              {{ $t("OSInfo") }}
            </vs-td>
            <vs-td>
              {{ deviceDetails.osInfo }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>
              {{ $t("BrowserName") }}
            </vs-td>
            <vs-td>
              {{ deviceDetails.browserName }}
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>
              {{ $t("DeviceName") }}
            </vs-td>
            <vs-td>
              <span v-if="deviceDetails.deviceName">
                {{ deviceDetails.deviceName }}
              </span>
              <span v-else> - </span>
            </vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>
              {{ $t("IP") }}
            </vs-td>
            <vs-td>
              {{ deviceDetails.ip }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>
<style scoped>
table tr td:first-child {
  width: 200px;
  background-color: #b4cad8;
  padding: 0.5rem;
  color: #647077;
}
table tr td:last-child {
  text-align: right;
  padding-right: 2rem;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
      name:"basketManagement_WebSiteBaskets_DevicePopup",

  props: {
    show: { default: false },
    Basketid: {
      default: "",
    },
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
    ...mapGetters({
      deviceDetails: "basket/deviceDetails",
    }),
  },
  methods: {
    ...mapActions({
      getBasketDeviceInfo: "basket/getBasketDeviceInfo",
    }),
  },
  watch: {
    show() {
      if (this.show == true) {
        this.getBasketDeviceInfo(this.Basketid);
      }
    },
  },
};
</script>





